import { render, staticRenderFns } from "./JournalDeliveryOfSamples.vue?vue&type=template&id=4772a423&scoped=true"
import script from "./JournalDeliveryOfSamples.vue?vue&type=script&lang=js"
export * from "./JournalDeliveryOfSamples.vue?vue&type=script&lang=js"
import style0 from "./JournalDeliveryOfSamples.vue?vue&type=style&index=0&id=4772a423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772a423",
  null
  
)

export default component.exports